// 📁 config/settingsMenuConfig.js
//
// Source of truth for the Settings left menu.
//
// Top-level structure:
//   Profile
//   Products        ← clickable page, no children
//   Integrations    ← clickable page, no children
//   Organisation    ← expand-only parent, groups ALL active settings tabs:
//                     - Static org tabs (General, Access, Lockers)
//                     - Active integration tabs (Control, IR, TTLock)
//   Admin Roles
//   Site Management
//
// The split between ORGANISATION_TABS and INTEGRATION_TABS is preserved
// because they're different conceptually (and come from different pages
// to toggle). They just share a common parent in the menu.

import { CONSTANTS_SETTINGS } from './settingsContainer';

// ── SettingGroup IDs from DB ────────────────────────────────────────────────
// Keep in sync with Organisation.SettingGroup. Values confirmed 2026-04-21.
export const SETTING_GROUP_IDS = {
	ZEZAMII_LOCKER: 23,
	ACCESS: 24,
	GENERAL: 25,
	CONTROL: 26,
	INNER_RANGE: 27,
	AVIGILON_ALTA: 32,
	TTLOCK: 33
	// ROOMS:       <fill in after running 001_add_rooms_module.sql>
};

// ── Static menu keys (not backed by SettingGroup) ───────────────────────────
export const STATIC_KEYS = {
	PROFILE: CONSTANTS_SETTINGS.PERSON_SETTING_TYPE,
	PRODUCTS: 'products',
	INTEGRATIONS: 'integrations',
	ROLES: 'roles',
	SITES: 'sites-and-floors'
};

// ── Organisation sub-tabs — org-level settings ──────────────────────────────
// General is always visible. Access / Lockers gated by their product flag.
export const ORGANISATION_TABS = [
	{ key: SETTING_GROUP_IDS.GENERAL, label: 'General' /* no flag */ },
	{ key: SETTING_GROUP_IDS.ACCESS, label: 'Access', moduleFlag: CONSTANTS_SETTINGS.ACCESS_MODULE },
	{ key: SETTING_GROUP_IDS.ZEZAMII_LOCKER, label: 'Lockers', moduleFlag: CONSTANTS_SETTINGS.LOCKER_MODULE }
];

// ── Integration sub-tabs — hardware integrations ────────────────────────────
// Appended to the Organisation group at render time. Kept as a separate
// array because Integrations page reads from the same source of truth.
export const INTEGRATION_TABS = [
	{ key: SETTING_GROUP_IDS.CONTROL, label: 'Control', moduleFlag: CONSTANTS_SETTINGS.CONTROL_MODULE },
	{ key: SETTING_GROUP_IDS.INNER_RANGE, label: 'Inner Range', moduleFlag: CONSTANTS_SETTINGS.INNER_RANGE_MODULE },
	{ key: SETTING_GROUP_IDS.TTLOCK, label: 'TTLock', moduleFlag: CONSTANTS_SETTINGS.TTLOCK_MODULE }
];
